import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const DigitalTwin = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[1].title)} menuList={menuList[1].list} backgroundImage="/imgs/bg_digitaltwin" />
      <div className="digital_twin_wrap" style={{ maxWidth: "1440px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default DigitalTwin;
